<div class="graphic">
    <canvas
        baseChart
        class="graphic"
        [data]="pieChartData"
        [labels]="pieChartLabels"
        [chartType]="pieChartType"
        [options]="pieChartOptions"
        [plugins]="pieChartPlugins"
        [legend]="pieChartLegend"
    >
    </canvas>
</div>
